import { useState, useEffect } from 'react'

export function useLiveVisitors(min = 15, max = 45) {
  const [visitors, setVisitors] = useState(
    Math.floor(Math.random() * (max - min + 1) + min),
  )

  useEffect(() => {
    const interval = setInterval(
      () => {
        setVisitors((prev) => {
          // Fluctuate by -3 to +5 visitors
          const change = Math.floor(Math.random() * 9) - 3
          let newValue = prev + change

          // Keep within bounds
          if (newValue < min) newValue = min + Math.floor(Math.random() * 5)
          if (newValue > max) newValue = max - Math.floor(Math.random() * 5)

          return newValue
        })
      },
      5000 + Math.random() * 5000,
    ) // Update every 5-10 seconds

    return () => clearInterval(interval)
  }, [min, max])

  return visitors
}
